export default "__VITE_ASSET__abb56729__"